import { Component, ViewEncapsulation } from '@angular/core';

// An attribute selector rather than an element one, so the host stays the .alert div itself and
// remains a direct flex child of .content-container - an extra wrapper element would pick up the
// container's row gap and shift the spacing of every panel.
@Component({
  selector: '[landing-page-warning]',
  templateUrl: './landing-page-warning.component.html',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'alert alert-warning' },
})
export class LandingPageWarningComponent {
}
